import type { SvgIconProps } from './types.js';

const MatkahuoltoLogo = ({ width = 36, height = 20 }: SvgIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26.24 16"
        fill="none"
    >
        <title>Matkahuolto logo</title>

        <path
            fill="#001e60"
            d="M8.92,6.3h-.52s-.05.02-.05.05v3.12s.02.05.05.05h.52s.05-.02.05-.05v-.94s.02-.02.03,0l.77.97s.03.02.05.02h.69s.04-.03.02-.05l-1.01-1.13s0-.02,0-.03l1-1.14s0-.05-.02-.05h-.69s-.04,0-.05.02l-.76.96s-.03,0-.03,0v-1.74s-.02-.05-.05-.05h0Z"
        />
        <path
            fill="#001e60"
            d="M14.98,9.51h.52s.05-.02.05-.05v-1.37c0-.22-.04-.4-.12-.56-.08-.15-.19-.27-.33-.35-.14-.08-.3-.12-.49-.12-.16,0-.3.03-.43.09-.12.05-.21.12-.29.21,0,.01-.03,0-.03,0v-1.02s-.02-.05-.05-.05h-.52s-.05.02-.05.05v3.12s.02.05.05.05h.52s.05-.02.05-.05v-1.28c0-.19.05-.34.15-.44s.23-.15.4-.15.3.05.39.15.14.25.14.44v1.28s.02.05.05.05h0Z"
        />
        <path
            fill="#001e60"
            d="M17.59,9.51h.52s.05-.02.05-.05v-2.31s-.02-.05-.05-.05h-.52s-.05.02-.05.05v1.28c0,.19-.05.34-.14.44-.1.1-.23.15-.4.15s-.3-.05-.39-.15-.14-.25-.14-.44v-1.28s-.02-.05-.05-.05h-.52s-.05.02-.05.05v1.37c0,.21.04.4.12.55.08.16.2.27.34.35.14.08.31.12.5.12.15,0,.28-.03.41-.09.11-.05.21-.12.28-.21,0-.01.03,0,.03,0v.21s.02.05.05.05h0Z"
        />
        <path
            fill="#001e60"
            d="M19.71,7.06c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25,1.25-.56,1.25-1.25-.56-1.25-1.25-1.25ZM19.71,9c-.38,0-.68-.31-.68-.68s.31-.68.68-.68.68.31.68.68-.31.68-.68.68Z"
        />
        <path
            fill="#001e60"
            d="M24.98,7.06c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25,1.25-.56,1.25-1.25-.56-1.25-1.25-1.25ZM24.98,9c-.38,0-.68-.31-.68-.68s.31-.68.68-.68.68.31.68.68-.31.68-.68.68Z"
        />
        <path
            fill="#001e60"
            d="M3.26,6.48h-.61s-.04.01-.04.03l-.94,2.19s-.02.01-.03,0l-.94-2.19s-.02-.03-.04-.03H.05s-.05.02-.05.05v2.94s.02.05.05.05h.52s.05-.02.05-.05v-1.85s.02-.02.03,0l.78,1.87s.02.03.04.03h.4s.04-.01.04-.03l.77-1.87s.03-.01.03,0v1.85s.02.05.05.05h.52s.05-.02.05-.05v-2.94s-.02-.05-.05-.05h0Z"
        />
        <path
            fill="#001e60"
            d="M23.63,7.11h-.48s-.02,0-.02-.02v-.53s-.02-.05-.05-.05h-.52s-.05.02-.05.05v.53s0,.02-.02.02h-.23s-.05.02-.05.05v.41s.02.05.05.05h.23s.02,0,.02.02v1.14c0,.5.26.75.77.75h.34s.05-.02.05-.05v-.47s-.02-.05-.05-.05h-.48s-.02,0-.02-.02v-1.31s0-.02.02-.02h.48s.05-.02.05-.05v-.41s-.02-.05-.05-.05h0Z"
        />
        <path
            fill="#001e60"
            d="M22.19,8.94h-.35s-.02,0-.02-.01v-2.59s-.02-.05-.05-.05h-.52s-.05.02-.05.05v2.42c0,.5.26.75.77.75h.21s.05-.02.05-.05v-.47s-.02-.05-.05-.05h0Z"
        />
        <path
            fill="#001e60"
            d="M6.17,9.46v-2.34s-.02-.05-.05-.05h-.48s-.05.02-.05.05v.2s-.02.02-.03.01c-.07-.08-.3-.28-.66-.28h0c-.65,0-1.25.53-1.25,1.24s.6,1.25,1.25,1.25h0c.36,0,.58-.21.66-.28,0-.01.03,0,.03.01v.2s.02.05.05.05h.48s.05-.02.05-.05h0ZM4.92,8.98c-.38,0-.68-.3-.68-.69s.31-.68.68-.68.68.32.68.69-.31.68-.68.68Z"
        />
        <path
            fill="#001e60"
            d="M12.35,9.51h.48s.05-.02.05-.05v-2.34s-.02-.05-.05-.05h-.48s-.05.02-.05.05v.2s-.02.02-.03.01c-.07-.08-.3-.28-.66-.28h0c-.65,0-1.25.53-1.25,1.24s.6,1.25,1.25,1.25h0c.36,0,.58-.21.66-.28,0-.01.03,0,.03.01v.2s.02.05.05.05h0ZM11.62,8.98c-.38,0-.68-.3-.68-.69s.31-.68.68-.68.68.32.68.69-.31.68-.68.68Z"
        />
        <path
            fill="#001e60"
            d="M7.43,7.61h.48s.05-.02.05-.05v-.41s-.02-.05-.05-.05h-.48s-.02,0-.02-.02v-.53s-.02-.05-.05-.05h-.52s-.05.02-.05.05v.53s0,.02-.02.02h-.23s-.05.02-.05.05v.41s.02.05.05.05h.23s.02,0,.02.02v1.14c0,.5.26.75.77.75h.34s.05-.02.05-.05v-.47s-.02-.05-.05-.05h-.48s-.02,0-.02-.02v-1.31s0-.02.02-.02h0Z"
        />
        <path
            fill="#001e60"
            d="M5.5,5.35h2.68c.05,0,.1-.03.13-.08.93-1.57,2.65-2.62,4.61-2.62s3.67,1.05,4.61,2.62c.03.05.08.08.13.08h2.68c.06,0,.11-.06.09-.12-1.13-3.05-4.06-5.23-7.51-5.23s-6.38,2.18-7.51,5.23c-.02.06.02.12.09.12h0Z"
        />
        <path
            fill="#001e60"
            d="M20.34,10.65h-2.68c-.05,0-.1.03-.13.08-.93,1.57-2.65,2.62-4.61,2.62s-3.67-1.05-4.61-2.62c-.03-.05-.08-.08-.13-.08h-2.68c-.06,0-.11.06-.09.12,1.13,3.05,4.06,5.23,7.51,5.23s6.38-2.18,7.51-5.23c.02-.06-.02-.12-.09-.12h0Z"
        />
    </svg>
);

export default MatkahuoltoLogo;
